import {APIServiceResponse} from '@custom-types/APIServiceResponse';
import {HttpRequest} from '@services/HttpClient';
import {trackErrorEvents} from '@utils/googleAnalytics/googleAnalyticsEvents';
import {getAPIUrl} from '@utils/service.utils';

type APIResponseData = {
  message: {
    title: string;
    description: string;
    ios_app_url: string;
    android_app_url: string;
  };
};

export type JoinDarnaPayloadType = Record<string, any>;

export function joinDarna({...payload}: JoinDarnaPayloadType) {
  const requestOptions = {
    method: 'POST' as const,
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      ...payload,
      responseKey: payload?.responseKey || '',
    }),
  };
  const endpoint = 'search/capillary/register';
  const httpRequest = new HttpRequest<APIServiceResponse<APIResponseData>>(
    getAPIUrl('search', endpoint),
    requestOptions
  );

  return {
    send: async () => {
      try {
        const response = await httpRequest.send();
        return {
          success: true,
          errorMessage: '',
          message: parseSuccessResponse(response.data),
        };
      } catch (error: any) {
        trackErrorEvents({
          type: 'request_lead_generation_failed',
          errorStack: error,
        });
        throw error;
      }
    },
    abort: httpRequest.abort,
  };
}

function parseSuccessResponse(data: APIResponseData) {
  return {
    title: data?.message.title || 'Thank You for Subscribing to Darna!',
    description:
      data?.message.description ||
      'Access Darna rewards easily within Live Aldar app.',
    appUrls: {
      ios: data?.message.ios_app_url || '',
      android: data?.message.android_app_url || '',
    },
  };
}
